// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryBreadcrumbs_container__35kuV"};